// extracted by mini-css-extract-plugin
export var box = "Slide-module--box--92ad0";
export var box_md = "Slide-module--box_md--3da6d";
export var box_xmd = "Slide-module--box_xmd--9081a";
export var box_flex = "Slide-module--box_flex--6dbfd";
export var box_lg = "Slide-module--box_lg--61aa0";
export var box_sm = "Slide-module--box_sm--c52b0";
export var box_outer = "Slide-module--box_outer--edde7";
export var box_whiteBg = "Slide-module--box_white-bg--f665a";
export var box_noMarginBottom = "Slide-module--box_no-margin-bottom--f55e7";
export var box_noPadding = "Slide-module--box_no-padding--cbb68";
export var box_outerGray = "Slide-module--box_outer-gray--05565";
export var box_dark = "Slide-module--box_dark--4b9e4";
export var box_zIndex = "Slide-module--box_z-index--94b6e";
export var box_zIndex6 = "Slide-module--box_z-index-6--8edc6";
export var box_eventsWithLine = "Slide-module--box_events-with-line--b8b86";
export var box_featuresAo = "Slide-module--box_features-ao--8a03f";
export var box_verticalPaddings = "Slide-module--box_vertical-paddings--aaa47";
export var clearP = "Slide-module--clearP--5235b";
export var clearP_vc = "Slide-module--clearP_vc--484b1";
export var card = "Slide-module--card--7ca56";
export var interactive = "Slide-module--interactive--97527";
export var img = "Slide-module--img--7fbcd";
export var fadeInAnimation = "Slide-module--fadeInAnimation--c1f9b";
export var placeHolderShimmer = "Slide-module--placeHolderShimmer--389c8";